import { Component } from '@angular/core';
import {  ViewChild } from '@angular/core';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { IRuta } from '../models/ruta';
import { RutaService } from '../services/ruta.service';
import { AuthService } from '../services/auth.service';
import ICredencialUsuario from '../models/credencial';
import { IEstatus } from '../models/estatus';
import { IMes } from '../models/mes';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IHistoricoFoliosDeProyecto } from '../models/historico_folios';
import { IDataGuardarFolio } from '../models/data_folio';
import { IResultadoGeneral } from '../models/resultadogeneral';
import { IFolioMensual } from '../models/FolioMensual';
import { IrptFolioRutaMensual } from '../models/rptFolioMensual';
import { saveAs } from 'file-saver';
import { FolioUnidadesService } from '../services/foliounidades.service';
import { IFolioUnidad } from '../models/foliounidades';
import { CiudadService } from '../services/ciudad.service';
import { ICiudad } from '../models/ciudad';
import { ConfunidadService } from '../services/confunidad.service';
import { IConfiguracionUnidad } from '../models/confUnidad';
import { Ifolios } from '../models/foliosunidadesindividuales';
import { find } from 'rxjs';
import { IUnidadessinfolio } from '../models/unidadesinfolio';
import { ChoferService } from '../services/chofer.service';
import { FolioUnicoRutasService } from '../services/folioUnicoRutas.service';

@Component({
  selector: 'app-foliounicorutas',
  templateUrl: './foliounicorutas.component.html',
  styleUrls: ['./foliounicorutas.component.scss']
})
export class FoliounicorutasComponent {
@ViewChild('dt1') dt!: Table;
  @ViewChild('dt2') dt2!: Table;
  lstRutas: IRuta[] = [];
  loading: boolean = false;
  /*Colores*/
  color_rojo_especial: string = '#FF0000';
  color_gris_deshabilitadas: string = '#D9D9D9';
  messageColabOdoo= { totalReg:0,addedReg:0,updtReg:0,failAddReg:0,failUpdReg:0,invalidFolios:0 };
  dspSyncroOdoo:boolean=false;
  btnRevOdoo:boolean=false;
  loadingSyncro:boolean=false;
  lstInvalidFol:any=[];
  loadingInvRfc:boolean=false;
  lstFailAdd:any=[];
  loadingFailAdd:boolean=false;
  lstFailUpdt:any=[];
  loadingFailUpdt:boolean=false;
  //Registro
  user: ICredencialUsuario = {};
  lstEstatus: IEstatus[] = [{
    id: 1,
    nombre: 'ACTIVA'
  },
  {
    id: 0,
    nombre: 'INACTIVA'
  }];

  //PARA EL Agregar Folio
  dsbAgregarfolio: boolean = false;
  desc_num: string = '';
  meses: IMes[] = [
    { num_mes: 1, nombre: "Enero" },
    { num_mes: 2, nombre: "Febrero" },
    { num_mes: 3, nombre: "Marzo" },
    { num_mes: 4, nombre: "Abril" },
    { num_mes: 5, nombre: "Mayo" },
    { num_mes: 6, nombre: "Junio" },
    { num_mes: 7, nombre: "Julio" },
    { num_mes: 8, nombre: "Agosto" },
    { num_mes: 9, nombre: "Septiembre" },
    { num_mes: 10, nombre: "Octubre" },
    { num_mes: 11, nombre: "Noviembre" },
    { num_mes: 12, nombre: "Diciembre" }];
  selectedMes: IMes = {
    num_mes: -1,
    nombre: ""
  }
  dataAgregarFolio:any;
//  REGEX_CARACTERES: any =/^(?=(?:.*[A-Za-z]){2})(?=(?:.*[0-9]){2})(?=(?:.*[@$?¡\-_]){1})\S{6,9}$/;;
  //REGEX_CARACTERES: any =/^(?=(?:.*[A-Za-z]){2})(?=(?:.*[-]){1})(?=(?:.*[0-9]){1})\S{3,9}$/
  //REGEX_CARACTERES: any = /^[A-Za-z]{2}-[0-9]{1}$/;
  REGEX_CARACTERES: any = /^[A-Za-z]{2}-\d+$/;
  foliosForm: FormGroup = new FormGroup({
    idx: new FormControl(0, [Validators.required]),
    ruta_id: new FormControl(0, [Validators.required]),
    num_folio_proyecto: new FormControl('',[Validators.required, Validators.pattern(this.REGEX_CARACTERES)])
  });
  //
  dsbgestionfolios: boolean = false;
  anio: any;
  clv_operacion:number=0;
  dataFolioEditar:any;
  lstHistorico: IHistoricoFoliosDeProyecto[]=[];
  loadinglst:boolean=false;
  years: number[] = [];
  dsbAgregarHerramientasEditar:boolean=false;
  num_anio_rpt:number=0;
  dbsReportes:boolean=false;
  lstFolioUnico:any[]=[];
  selectedMesReporte1: IMes = {
    num_mes: -1,
    nombre: ""
  }
  lstunidadesEstatus = [
    { id: 0, nombre: 'Inactiva' },
    { id: 1, nombre: 'Activa' },
    { id: 3, nombre: 'Baja de Operación' },
    { id: 4, nombre: 'Activa con Reporte' }
  ];

  anioReporte1: any;
  lstFolioMensual:IFolioMensual[]=[];
  lstRptFolioMensual: IrptFolioRutaMensual[]=[];
  loading_reporte:boolean=false;
  constructor(
    private rutaService: RutaService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private folioUnidadesService: FolioUnidadesService,
    private auth: AuthService,
    private choferService:ChoferService,
    private foliounicoservice:FolioUnicoRutasService,
    private ciudadService: CiudadService,
    private confUnidadService: ConfunidadService,) {
    this.cargarInformacionUsuario();
    this.getListaDeCiudades();
    this.cargarListadoConfUnidad();
    this.initializeYears();
  }
  ExportarExcel(){
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    this.foliounicoservice.getListadoDynEstatusUnidad().subscribe(resp => {
      if(resp.length>0){
        import("xlsx").then(xlsx => {
          const worksheet = xlsx.utils.json_to_sheet(resp);
          const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
          const excelBuffer: any = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array"
          });
          this.saveAsExcelFile(excelBuffer, "TablaFolioUnico_Al_"+dateFormat);
        });    
      }else{
        this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Informativo', detail: 'No se encontro información en catalogo.' });
      }
    });    
  }
  CancelSyncro(){
    this.dspSyncroOdoo=false;
    this.btnRevOdoo=false;
    this.loadingSyncro=false;
    this.messageColabOdoo={ totalReg:0,addedReg:0,updtReg:0,failAddReg:0,failUpdReg:0,invalidFolios:0 };
  }

  getFoliosUnicos(){
    this.foliounicoservice.getListadoEstatusUnidad().subscribe((resp)=>{
      this.lstFolioUnico=resp;
      setTimeout(() => {
      }, 200);
    })
  }

  ngOnInit(): void {
    this.getFoliosUnicos();
    //this.getFolioUnidades();
    this.anio_valid = new Date().getFullYear();
    this.num_anio_rpt = new Date().getFullYear();
  }

  inicializarFechas() {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    let num_mes: number = +getMonth;
    this.meses.map((mes) => {
      if (mes.num_mes == num_mes) {
        this.selectedMes.nombre = mes.nombre;
        this.selectedMes.num_mes = mes.num_mes;
        this.selectedMesReporte1.nombre = mes.nombre;
        this.selectedMesReporte1.num_mes = mes.num_mes;
      }
    });
    this.anio = getYear;


  }

  cargarInformacionUsuario() {
    this.user = this.auth.user;
  }

  initializeYears(): void {
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= currentYear - 5; year--) {
      this.years.push(year);
    }
  }


  lstCiudades: ICiudad[] = [];
  lstConfUnidad: IConfiguracionUnidad[] = [];

  getListaDeCiudades() {
    this.ciudadService.getListadoCiudades().subscribe((resp) => {
      this.lstCiudades = resp;
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en <Listar Ciudades>', detail: 'Contacte al Administrador del Sitio' });
      });
  }



  cargarListadoConfUnidad() {
    this.confUnidadService.getListadoConfUnidades().subscribe((resp) => {
      this.lstConfUnidad = resp;
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en cargar <Conf. de Unidad>', detail: 'Contacte al Administrador del Sitio' });
      });
  }


  editarFolio(data:any){

  }
  mostrarModalAgregarFolio(data: any) {
    this.dataAgregarFolio=data;
    this.dsbAgregarfolio = true;
}


  cancelarModalAgregarFolio() {
    this.loading=false;
    this.dsbAgregarfolio = false;
    this.getFoliosUnicos();
    this.resetearFormulario();
    this.desc_num = '';
  }

  habilitarEdicionFolios() {
    this.habilitarTodos();
  }

  habilitarEdicionFolios_historico() {
    this.foliosForm.get('num_folio_proyecto')!.enable();
  }

  habilitarTodos(){
    this.foliosForm.get('num_mes')!.enable();
    this.foliosForm.get('num_anio')!.enable();
    this.foliosForm.get('num_folio_proyecto')!.enable();
  }




  lstfolios: Ifolios[] = [];
  gestionarFoliosDeRuta(data: IFolioUnidad) {
  this.lstfolios=[]
    this.loading=true;
    this.folioUnidadesService.getFolioUnidadesindividuales(data.num_economico, data.id_unidad_transporte).subscribe((resp)=> {
    this.lstfolios = resp;
    setTimeout(() => {
      this.loading = false;
     this.desc_num = data.num_economico;
     this.dsbgestionfolios = true;
    },
      300);
    },

    (error) => {
      this.loading = false;
      this.messageService.add({ severity: 'error', summary: 'Error al obtener los<Folio de Proyecto Mensual> ', detail: 'Contacte al Administrador del Sitio' });
    })




  }
  revFolioUnicoOdoo() {
    this.btnRevOdoo=true;
    type IsomeType = {[key: string]:any};
    const fecha = new Date();
    const mes = fecha.getMonth() + 1;
    const anio = fecha.getFullYear();
    this.foliounicoservice.getApiOdoo(mes,anio).subscribe(resp =>{
      let data: IsomeType = resp;
      if(!data['status'])
        this.messageService.add({ severity: 'error', summary: 'Error de Conexión', detail: 'Revise su conexión a internet.' });
      else{
        this.dspSyncroOdoo=true;
        this.loadingSyncro=true;

        setTimeout(() => {
          this.messageColabOdoo = {
            totalReg:data['totalReg'],
            addedReg:data['regAdded'],
            updtReg:data['updtReg'],
            failAddReg:data['failAddReg']==undefined?0:data['failAddReg'].length,
            failUpdReg:data['failUpdReg']==undefined?0:data['failUpdReg'].length,
            invalidFolios:data['invalidFolios']==undefined?0:data['invalidFolios'].length
          };
          if(this.messageColabOdoo.invalidFolios!=0){
            let dataInvFol: IsomeType = data['invalidFolios'];
            this.lstInvalidFol=dataInvFol;
          }
          if(this.messageColabOdoo.failAddReg!=0){
            let dataAddFail: IsomeType = data['failAddReg'];
            this.lstFailAdd=dataAddFail;
          }
          if(this.messageColabOdoo.failUpdReg!=0){
            let dataUpdtFail: IsomeType = data['failUpdReg'];
            this.lstFailUpdt=dataUpdtFail;
          }
          this.loadingSyncro=false;
        }, 300);
      }
    },(error) => {
      this.btnRevOdoo=false;
      this.dspSyncroOdoo=false;
      this.messageService.add({ severity: 'error', summary: 'Error en <Actualización Choferes de Odoo>', detail: 'Contacte al Administrador del Sitio' });
    });
  }
  exportarExcelLst(data:any,fileName: string) {
    if(!data.length || typeof data ==='undefined'){
      this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion del Catalogo para exportar(Excel)');
    } else {
      import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(data);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer: any = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array"
        });
        this.saveAsExcelFile(excelBuffer, fileName);
      });
    }
  }
  exportFail(type:number){
    type IsomeType = {[key: string]:any};
    const seen = new Set();
    let dt: IsomeType[];
    let dt2: any;
    switch(type)
    {
      case 1:
        dt= this.lstInvalidFol;
        dt2 = dt.map(x => {
          return { Folio: x[0] };
        }).filter(i=>{
            if(seen.has(i.Folio)) return false;
            seen.add(i.Folio);
            return true;
        }).sort((a,b)=>a.Folio.length-b.Folio.length);
        //.sort((a,b)=> a.Folio.localeCompare(b.Folio, 'es', { sensitivity: 'base' }));
        this.exportarExcelLst(dt2,'ReporteFolioUnicoInvalidoOdoo_a_TDO');
      break;
      case 2:
        dt= this.lstFailAdd;
        dt2 = dt.map(x => {
          return { Folio: x[0] };
        }).filter(i=>{
            if(seen.has(i.Folio)) return false;
            seen.add(i.Folio);
            return true;
        }).sort((a,b)=>a.Folio.length-b.Folio.length);
        //.sort((a,b)=> a.Folio.localeCompare(b.Folio, 'es', { sensitivity: 'base' }));
        this.exportarExcelLst(dt2,'ReporteFallosAgregarFolioUnicoOdoo_a_TDO');
      break;
      case 3:
        dt= this.lstFailUpdt;
        dt2 = dt.map(x => {
          return { Folio: x[0] };
        }).filter(i=>{
            if(seen.has(i.Folio)) return false;
            seen.add(i.Folio);
            return true;
        }).sort((a,b)=>a.Folio.length-b.Folio.length);
//        .sort((a,b)=> a.Folio.localeCompare(b.Folio, 'es', { sensitivity: 'base' }));
        this.exportarExcelLst(dt2,'ReporteFallosActualizarFolioUnicoOdoo_a_TDO');
      break;
    }
  }

  cancelarModalHistoricoFolios() {
    this.lstHistorico=[];
    this.desc_num = '';
    this.dsbgestionfolios = false;
  }



  guardarInformacionFolio() {
    this,this.loading=true;
    let data_enviar = {
      folio: this.foliosForm.get('num_folio_proyecto')?.value,
      ruta_id: this.dataAgregarFolio.clave_ruta,
      user: this.user.cod!,
    };

    this.foliounicoservice.postFolio(data_enviar).subscribe((resp)=> {
      if(resp.status===true){
        this.messageService.add({ key: 'msj', severity: 'success', summary: 'Registro Exitoso', detail: resp.message });
        this.cancelarModalAgregarFolio();
      }
      if(resp.status===false){
        this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Advertencia', detail: resp.message });
      }
      setTimeout(() => {
        this.loading=false;
      }, 500);
    },
    (error)=> {
      this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <Guardar Folio del Mes>', detail: 'Contacte al Administrador del Sitio' });
      this.loading=false;
    });
  }

  mostrarDialogoInformativo(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
  }

  mostrarModalEditarFolio(data:any){
    this.foliosForm.controls['num_folio_proyecto'].setValue(data.num_folio_proyecto);
    this.dataFolioEditar=data;
    this.dsbAgregarHerramientasEditar = true;
  }

  cancelarModalEditarFolio(){
    this.dsbAgregarHerramientasEditar = false;
    this.dsbgestionfolios = false;
    this.getFoliosUnicos();

    this.resetearFormulario();
    //
    this.foliosForm.get('num_mes')?.enable();
    this.foliosForm.get('num_anio')?.enable();
  }

  resetearFormulario(){
    this.foliosForm.controls['ruta_id'].setValue(0);
    this.foliosForm.controls['num_folio_proyecto'].setValue('');

  }

  guardarInformacionFolioEditar(){
    this.loadinglst=true;
    let data_enviar  ={
      folio: this.foliosForm.get('num_folio_proyecto')?.value,
      ruta_id: this.dataFolioEditar.clave_ruta,
    };
    this.foliounicoservice.editFolio(data_enviar).subscribe((resp)=> {
      setTimeout(() => {
        if(resp.status===true){
          this.messageService.add({ key: 'msj', severity: 'success', summary: 'Registro Exitoso', detail: resp.message });
          this.cancelarModalAgregarFolio();

        }
        if(resp.status===false){
          this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Advertencia', detail: resp.message });
        }
      },
        300);

      this.cancelarModalEditarFolio();
      this.getFolioUnidades();
      this.loadinglst=false;
    },
    (error)=> {
      this.loadinglst=false;
      this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <Editar Folio de Ruta>', detail: 'Contacte al Administrador del Sitio' });
    });
  }




  lstFolioUnidad: IFolioUnidad[]=[]
  getFolioUnidades() {

    this.loading = true;
    this.folioUnidadesService.getFolioUnidades().subscribe((resp) => {
      this.lstFolioUnidad = resp;
      setTimeout(() => {
        this.loading = false;
      },
        800);

    },
      (error) => {
        this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado de RUTAS');
        this.loading = false;
      });
  }

  dbsvalidacion:boolean =false
  anio_valid:number =0 ;

  validacionmen(){
    this.inicializarFechas();
    this.dbsvalidacion =true


  }

  deshabilitartabla :boolean=false;
num_registros:number =0;
  lstUnidadessinfolio:IUnidadessinfolio[]=[];
  getvalidacionfolios() {
    this.lstUnidadessinfolio=[];

    if (!this.anio_valid || this.selectedMesReporte1.num_mes === -1) {
      this.mostrarDialogoInformativoSinInformacion('Mes y Año deben seleccionarse para consultar información.');
      this.loading_reporte = false;
    } else {

      this.folioUnidadesService.getvalidacionsinfolios(this.anio_valid, this.selectedMesReporte1.num_mes).subscribe(
        (resp) => {
          this.lstUnidadessinfolio = resp;


          // Verificamos si tenemos resultados para habilitar la tabla
          if (this.lstUnidadessinfolio.length > 0) {
            this.deshabilitartabla = true;
            this.num_registros= this.lstUnidadessinfolio.length
            let var1 = resp.length

          } else {
            this.deshabilitartabla = false;
          }
        },
        (error) => {
          // En caso de error
          this.loading_reporte = false;
          this.messageService.add({
            key: 'msj',
            severity: 'error',
            summary: 'Error en <ReporteFoliosProyectoMensual>',
            detail: 'Contacte al Administrador del Sitio',
          });
        }
      );
    }
  }


  cancelarvalidacionmen(){
    this.dbsvalidacion = false;
    this.anio_valid  = new Date().getFullYear();

    this.selectedMesReporte1.num_mes = 0
    this.deshabilitartabla =false;
    this.lstUnidadessinfolio=[]
    this.num_registros =0
  }




  generarReporte1() {
   this.loading_reporte = true;
    this.lstFolioMensual = [];
    this.lstRptFolioMensual = [];
    if ((this.selectedMesReporte1 == null || this.selectedMesReporte1.num_mes == -1) || (this.num_anio_rpt == null)) {
      this.mostrarMensajeDeAlerta();
      //this.mostrarDialogoInformativoSinInformacion('Mes y Año deben seleccionarse para consultar informacion.');
      this.loading_reporte = false;
    } else {
      let mes = this.selectedMesReporte1.num_mes;

      this.cargarInformacionDelMes( mes, this.num_anio_rpt);
    }
  }

  mostrarMensajeDeAlerta() {
    this.loading = false;
    this.messageService.add({
      key: 'confirm',
      sticky: true,
      severity: 'info',
      summary: 'Falta Mes y/o Año',
      detail: 'Mes y Año deben seleccionarse para consultar informacion.'
    })
  }

  cancelarMensajeConfirmacion(){
    this.messageService.clear('confirm');
  }

  confirmarMensaje(){
    this.messageService.clear('confirm');
  }

  cargarInformacionDelMes( num_mes: number, num_anio_rpt: number) {

    this.folioUnidadesService.getListadoFolioMensual(num_mes, num_anio_rpt).subscribe((resp :any  ) => {



      if(resp.length === 0 || typeof resp === 'undefined')  {
        this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion del Catalogo para exportar(Excel)');
      } else {
        import("xlsx").then(xlsx => {
          const worksheet = xlsx.utils.json_to_sheet(resp);
          const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
          const excelBuffer: any = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array"
          });
          this.saveAsExcelFile(excelBuffer, "Folios_de_Unidades" + '_' + this.selectedMesReporte1.nombre + '_' + num_anio_rpt);
        });
      }
      this.loading_reporte = false;
    },
      (error) => {
        this.loading_reporte = false;
        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <ReporteFoliosProyectoMensual>', detail: 'Contacte al Administrador del Sitio' });
      });
  }



  abrirModalReportes() {
    this.inicializarFechas();
    this.dbsReportes = true;
  }


  cancelarModalReportes() {
     this.num_anio_rpt = new Date().getFullYear();
    this.dbsReportes = false;
    this.selectedMes = {
      num_mes: 0,
      nombre: ''
    }
    this.anio = null;

    this.selectedMesReporte1 = {
      num_mes: 0,
      nombre: ''
    }
    this.anioReporte1 = null;
  }



  saveAsExcelFile(buffer: any, fileName: string): void {
    //var FileSaver = require('file-saver');
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    saveAs(data, fileName + EXCEL_EXTENSION);

  }



  /*Filtro General para la informacion de tabla*/
  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }
    /*Filtro General para la informacion de tabla*/
  applyFilterGlobal2($event: any, stringVal: any) {
    this.dt2.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }


  mostrarDialogoInformativoSinInformacion(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '. <b>Contacte al Administrador.</b>';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
  }
}
